import React from 'react';
import { Badge } from '@/components/ui/badge';
import { InviteStatus } from '@/types/constants';

interface InviteStatusBadgeProps {
  status: InviteStatus;
}

const InviteStatusBadge: React.FC<InviteStatusBadgeProps> = ({ status }) => {
  const getVariant = () => {
    switch (status) {
      case 'sent':
        return 'info';
      case 'accepted':
        return 'success';
      case 'expired':
        return 'muted';
      default:
        return 'muted';
    }
  };

  const getLabel = () => {
    switch (status) {
      case 'sent':
        return 'Invite sent';
      case 'accepted':
        return 'Registered';
      case 'expired':
        return 'Invite expired';
      default:
        return 'Invite not sent';
    }
  };

  return (
    <Badge variant={getVariant()} className="font-medium">
      {getLabel()}
    </Badge>
  );
};

export default InviteStatusBadge;
